import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { makeSxStyles } from "ui";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import useRoutePlannerStore from "../../../state/route-planner-store";
import AddressBoxDraggable from "../address-box-component/address-box-draggable";
import { MapMarker } from "../../../components/map/map.types";

export interface RoutePlannerSidebarProps {
  customHeader?: React.ReactNode;
  sequencing?: boolean;
}

const RoutePlannerSidebarSequence: FC<RoutePlannerSidebarProps> = ({
  customHeader,
  // sequencing,
}) => {
  const styles = useStyles();
  const { sequencedAddresses, moveItem } = useRoutePlannerStore();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = sequencedAddresses.findIndex(
        (address: MapMarker) => address.id === active.id,
      );
      const newIndex = sequencedAddresses.findIndex(
        (address: MapMarker) => address.id === over?.id,
      );

      moveItem(oldIndex, newIndex);
    }
  };

  return (
    <Box sx={styles.routePlannerSidebar}>
      {customHeader}
      {sequencedAddresses && sequencedAddresses.length > 0 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={sequencedAddresses}
            strategy={verticalListSortingStrategy}
          >
            {sequencedAddresses.map((address: MapMarker, index: number) => (
              <AddressBoxDraggable
                {...address}
                key={address.id}
                index={index}
              />
            ))}
          </SortableContext>
        </DndContext>
      ) : (
        <Box sx={styles.noSequenceView}>
          <Typography>Sequence will appear below.</Typography>
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  routePlannerSidebar: {
    width: "340px",
    padding: "12px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    height: "65vh",
    overflow: "auto",
    marginTop: "0px",
    backgroundColor: "rgba(30, 30, 30, 0.95)",
    borderLeft: "1px solid rgba(65, 71, 77, 1)",
  },
  noSequenceView: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "40vh",
  },
}));

export default RoutePlannerSidebarSequence;
